
import { Component, Prop, Vue } from "vue-property-decorator";
import imageCompression from "browser-image-compression";
import { commonModule, offersModule } from "@/store/modules/store-accessor";
import { deepTrim, installationPhotoCompressionSettings } from "@/helpers/data";

@Component
export default class AddOfferPhotosModal extends Vue {
  @Prop() payload!: { offer: OfferDto };

  selectedFiles: File[] = [];
  photoModel = {
    photos: [] as File[],
    notes: "",
    previewUrls: [] as string[],
  };

  isUploading = false;
  pendingCompression = 0;

  photoRules = [
    (val: File[]) => !!val?.length || this.$t("photosRequired"),
    (val: File[]) => (val?.length || 0) <= 30 || this.$t("photoLengthRule"),
  ];

  photoNotesRules = [
    (val: string) => !val || val.length <= 50 || this.$t("notesForPhotoRule"),
  ];

  async previewPhotos(files: File[] | null) {
    this.revokePreviewUrls();
    this.photoModel.photos = [];
    this.photoModel.previewUrls = [];

    if (!files?.length) return;

    this.photoModel.previewUrls = files.map((file) =>
      URL.createObjectURL(file)
    );
    this.pendingCompression = files.length;
    const options = installationPhotoCompressionSettings();

    this.photoModel.photos = await Promise.all(
      files.map(async (file) => {
        try {
          return await imageCompression(file, options);
        } catch {
          return file;
        } finally {
          this.pendingCompression = Math.max(0, this.pendingCompression - 1);
        }
      })
    );
  }

  clearPhotos() {
    this.revokePreviewUrls();
    this.selectedFiles = [];
    this.photoModel.photos = [];
    this.photoModel.previewUrls = [];
    this.pendingCompression = 0;
  }

  revokePreviewUrls() {
    this.photoModel.previewUrls.forEach((url) => URL.revokeObjectURL(url));
  }

  beforeDestroy() {
    this.revokePreviewUrls();
  }

  hideModal() {
    commonModule.hideModal();
  }

  async addPhotos() {
    const form = this.$refs.form as Vue & { validate: () => boolean };
    if (!form.validate() || this.pendingCompression > 0) return;

    this.isUploading = true;
    try {
      const formData = new FormData();
      this.photoModel.photos.forEach((file) => formData.append("image", file));
      formData.append("notes", deepTrim(this.photoModel.notes));

      await offersModule.createOfferPhoto({
        installationId: String(this.payload.offer.installation_id),
        offerId: String(this.payload.offer.id),
        photo: formData,
      });
      this.hideModal();
    } finally {
      this.isUploading = false;
    }
  }
}
